import type { PropsWithChildren } from 'react'

import { GuideTourProvider } from '@/guide-tour/provider/GuideTourProvider'
import { GuideTourRouteListener } from '@/guide-tour/routing/GuideTourRouteListener'
import { createGuideTourRegistry } from '@/guide-tour/registry'
import { useFeatureFlagOn } from '@/hooks/useFeatureToggle'

import { useGuideTourAnalytics } from './utils/analytics'
import { validateOwnerSquads } from './utils/validateOwnerSquads'

const sellerGuideTourSetup = createGuideTourRegistry()

validateOwnerSquads(sellerGuideTourSetup.guideTourDefinitions)

const sellerGuideTourRegistry = sellerGuideTourSetup.registry

/** App wiring: registry, route listener, feature flags, and Segment `onInteraction`. */
export const GuideTourAppProvider = ({
  children,
}: Readonly<PropsWithChildren>) => {
  const isFeatureFlagOn = useFeatureFlagOn()
  const { onGuideTourInteraction } = useGuideTourAnalytics()

  return (
    <GuideTourProvider
      registry={sellerGuideTourRegistry}
      isFeatureFlagOn={isFeatureFlagOn}
      onInteraction={onGuideTourInteraction}
    >
      <GuideTourRouteListener />
      {children}
    </GuideTourProvider>
  )
}
